<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template #no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök kategori</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'BrandFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];
            await BackendRepository.getMediabankCategories().then((res) => {
                options = res.map((item) => ({
                    id: item.CatID,
                    label: item.CatName,
                    ...item,
                }));
            });

            return options;
        },
    },
};
</script>
